export default __webpack_public_path__ + "static/media/gamemaster.6ef22956.pdf";